<template>
<v-card max-width="800" class="pa-1 mx-auto ma-1 rounded-xl">
  <slot></slot>
</v-card>
</template>

<script>
export default {
  name: 'ContainerWrapper'
}
</script>

<style scoped>

</style>
